module.exports = __webpack_public_path__ + "media/images/icons/form_venue_step_3-c10c9b142bd5c3bde667aea36c1db6a4.svg";